import { render, staticRenderFns } from "./dynamicsSalesChart.vue?vue&type=template&id=2948ecaa&scoped=true"
import script from "./dynamicsSalesChart.vue?vue&type=script&lang=js"
export * from "./dynamicsSalesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948ecaa",
  null
  
)

export default component.exports